import { useQuery } from "@tanstack/react-query";
import {
  OverdueReceivableResponse,
  WalletService,
} from "@/services/wallet.service";

export const useFetchOverdueReceivables = ({
  currency,
  currentPage = 1,
  enabled = true,
}: {
  currency: string;
  currentPage?: number;
  enabled?: boolean;
}) => {
  const {
    data: overdueReceivables,
    isPending: isLoading,
    refetch,
    isRefetching,
    error,
  } = useQuery<OverdueReceivableResponse>({
    queryKey: ["overdue-receivables", currency, currentPage],
    queryFn: async () =>
      await WalletService.getOverdueReceivables({ currency, currentPage }),
    enabled,
  });

  return {
    overdueReceivables,
    isLoading,
    refetch,
    isRefetching,
    error: error ? (error as Error).message : null,
  };
};
